<template>
  <div class="" v-if="!globalAdherence == 0">
    <div class="headers">
      <div class="global-adherence-header">{{ $t("aderencia-global-0") }}</div>
      <div class="global-adherence-value">
        {{ globalAdherence ? globalAdherence + " %" : "-" }}
      </div>
    </div>
  </div>
  <div v-else class="all"></div>
</template>

<script>
import MediatorGDI from "../utilites/MediatorGDI";

export default {
  data() {
    return {
      screenIndicators: 0,
      globalAdherence: null,
    };
  },

  mounted() {
    MediatorGDI.notify(this, "init-footer");
  },
};
</script>

<style scoped>
.all {
  height: 40px;
  display: flex;
  width: 330px;
  align-items: center;
  position: absolute;
  bottom: 0;
}

.headers {
  display: grid;
  grid-template-columns: 1fr 1fr;
  font-size: 15px;
  font-weight: 500;
  justify-items: center;
  align-items: center;
}
</style>